import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'environments/environment';
import { Observable } from "rxjs";
import { TabelaPreco } from "app/module/tabela-preco";

@Injectable({
	providedIn: 'root'
})
export class TabelaPrecoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}tabela-preco`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public put(data: any, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url}tabela-preco/${id}/update`, {
				id_sistema: id,
				nome: data.value.nome,
				status: data.value.status,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public delete(data: number, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url}tabela-preco/${id}/update`, {
				id_sistema: id,
				isDeleted: data,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public get(): Observable<{ statusCode: number, message: string[], data: TabelaPreco[] }> {
		return this.http.get<{ statusCode: number, message: string[], data: TabelaPreco[] }>(`${this.url}tabela-preco`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getDetalhado(): Observable<{ statusCode: number, message: string[], data: any }> {
		return this.http.get<{ statusCode: number, message: string[], data: any }>(`${this.url}tabela-preco/detalhado`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOne(id: number): Observable<{ statusCode: number, message: string[], data: {tabela: TabelaPreco, itens: any[]} }> {
		return this.http.get<{ statusCode: number, message: string[], data: {tabela: TabelaPreco, itens: any[]} }>(`${this.url}tabela-preco/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
